import Menu from '~/icons/menu.svg';
import { StyledSmallIconButton, StyledHeaderSmallIconOptionText } from '../styled';
import { useTranslation } from '~/shared/utils/translation';
import { useSearchOverlay } from '~/services/search/useSearchOverlay';
import { closeMenu } from '../../N30MegaMenu/MegaMenu';

export const MobileMegaMenuButton = () => {
    const { translate } = useTranslation();
    const { setIsOverlayVisible } = useSearchOverlay();

    return (
        <StyledSmallIconButton
            href="/"
            onClick={(e) => {
                // If search overlay is open, close it before opening menu.
                // This avoids two competing mobile overlays at once.
                setIsOverlayVisible(false);

                const html = document.documentElement;
                if (html.hasAttribute('data-menu-open')) {
                    html.removeAttribute('data-menu-open');
                    closeMenu();
                } else {
                    html.setAttribute('data-menu-open', '');
                }

                e.preventDefault();
                e.stopPropagation();
            }}
        >
            <Menu />{' '}
            <StyledHeaderSmallIconOptionText>
                {translate('header.menu')}
            </StyledHeaderSmallIconOptionText>
        </StyledSmallIconButton>
    );
};
